module.exports = __webpack_public_path__ + "static/img/logo_old_del.b8364dc5.jpg";